import CreateFarmStore from './farm.create';
import ListFarmStore from './farm.list';
import FarmDetailsStore from './farm.details';

export const farmStores = {
  create: CreateFarmStore,
  list: ListFarmStore,
  details: FarmDetailsStore
}
